'use strict';

var util = {

    /**
     * @function
     * @description Initializes recaptcha form passthrough to allow recaptcha token to be obtained before triggering form submission (to allow compatibility with formModel) for non-ajax forms
     * @param {string} formSelector The form selector
     * @param {string} recaptchaSubmit The recaptcha replacement submit button selector
     * @param {string} submitButton The hidden actual form submit button selector
     */
    registerRecaptchaFormPassthrough: function (formSelector, recaptchaSubmit, submitButton) {
        if (!$(formSelector).length) {
            return;
        }
        if (!$(formSelector).hasClass('recaptcha-passthrough-enabled')) {
            $(formSelector + ' input').on('keypress', function(e) {
                if (e.which === 13) { // detect attempted form submission by enter key
                    let $form = $(this).parents(formSelector);
                    let $recaptchaSubmit = $form.find(recaptchaSubmit);
                    if ($recaptchaSubmit.length) {
                        e.preventDefault();
                        $recaptchaSubmit.trigger('click');
                    }
                }
            });
            $(formSelector + ' ' + recaptchaSubmit).on('click', function(e) {
                let $recaptchaSubmitButton = $(this);
                if ($recaptchaSubmitButton.hasClass('submit-pending')) {
                    return;
                }
                $recaptchaSubmitButton.addClass('submit-pending');
                setTimeout(function() {
                    // prevent double clicks
                    $recaptchaSubmitButton.removeClass('submit-pending');
                }, 9000);
                let $form = $recaptchaSubmitButton.parents(formSelector);
                if (typeof grecaptcha !== 'undefined') {
                    grecaptcha.execute(
                        $form.find('#recaptchaSiteKey').val(),
                        {
                            action: $form.find('#recaptchaAction').val()
                        }
                    ).then(function (token) {
                        if (token) { // if recaptcha did not return a token, leave with the initial token but it may be expired
                            $form.find('#recaptchaToken').val(token);
                        }
                        let $submitButton = $form.find(submitButton);
                        $submitButton.removeAttr('disabled');
                        $submitButton.addClass('submit-pending');
                        $submitButton.trigger('click');
                    });
                } else {
                    // if grecaptcha has been removed from the page context,
                    // attempt to continue to submit but it will most likely fail with
                    // a recaptcha error unless a token was already obtained
                    console.log('grecaptcha is not defined.');
                    let $submitButton = $form.find(submitButton);
                    $submitButton.removeAttr('disabled');
                    $submitButton.trigger('click');
                }
            });

            if (typeof grecaptcha !== 'undefined') {
                // To improve resiliency, initially populate recaptcha token in case later recaptcha call fails (however, this token may become expired)
                grecaptcha.ready(function () {
                    let $form = $(formSelector);
                    grecaptcha.execute(
                        $form.find('#recaptchaSiteKey').val(),
                        {
                            action: $form.find('#recaptchaAction').val()
                        }
                    ).then(function (token) {
                        $form.find('#recaptchaToken').val(token);
                    });
                });
            } else {
                console.log('grecaptcha is not defined.');
            }
            $(formSelector).addClass('recaptcha-passthrough-enabled');
        } else {
            console.log('recaptcha-utils: Form selector already initialized. Re-initialization prevented.');
        }
    }
};
module.exports = util;
